module.exports = __webpack_public_path__ + "img/1508323499.3a5457b9.jpg";